import { render, staticRenderFns } from "./TeachingMaterialInfo.vue?vue&type=template&id=677ad56c&scoped=true"
import script from "./TeachingMaterialInfo.vue?vue&type=script&lang=js"
export * from "./TeachingMaterialInfo.vue?vue&type=script&lang=js"
import style0 from "./TeachingMaterialInfo.vue?vue&type=style&index=0&id=677ad56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ad56c",
  null
  
)

export default component.exports